import React, { ReactElement } from 'react';

type Props = {
  // eslint-disable-next-line react/require-default-props
  className?: string;
};

const ResultSeparator = ({ className = '' }: Props): ReactElement => {
  return (
    <div className={`result-separator result-separator-${className}`}>
      <div className="result-separator-dot" />
      <div className="result-separator-dot" />
    </div>
  );
};

export default ResultSeparator;
